export default class Part {
    static render(width, mods) {
        mods = 1
        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = (WIDTH - 43.5 * mods) / 2 - (mods - 1) * 10.5
        let y = (HEIGHT - 74.6) / 2;
        return `<image href="${PARTS['switch_1']}" x="${x}" y="${y}" />`
    }
}
